import { Truck, Shield, RefreshCw, Heart, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
import BannerAd from '../../components/AdScript';

const fadeInUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

const FeaturesSection = () => {
  const features = [
    {
      icon: <Heart className="w-7 h-7" />,
      title: 'Handcrafted with Love',
      description: 'Each product is carefully crafted by skilled Bengali artisans',
      chip: 'from-clay-100 to-clay-200 text-clay-600',
    },
    {
      icon: <Shield className="w-7 h-7" />,
      title: 'Quality Guaranteed',
      description: 'We ensure every product meets our quality standards',
      chip: 'from-saffron-100 to-saffron-200 text-saffron-700',
    },
    {
      icon: <Truck className="w-7 h-7" />,
      title: 'Nationwide Delivery',
      description: 'Careful packaging and delivery across India',
      chip: 'from-cream-200 to-cocoa-200 text-cocoa-700',
    },
    {
      icon: <RefreshCw className="w-7 h-7" />,
      title: 'Easy Returns',
      description: '15-day return policy for your peace of mind',
      chip: 'from-rose-100 to-rose-200 text-rose-600',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-cream-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeInUp}
          className="text-center mb-12"
        >
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-clay-50 text-clay-600 rounded-full text-sm font-semibold mb-4">
            <Sparkles className="w-4 h-4" />
            Why Choose তন্তিকা?
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-cocoa-900">
            Crafted with Purpose, Delivered with Care
          </h2>
          <p className="text-cocoa-600 max-w-2xl mx-auto text-lg">
            We're more than just a marketplace - we're a community supporting traditional craftsmanship
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, ease: 'easeOut', delay: index * 0.08 }}
              className="group bg-white p-7 rounded-2xl border border-cream-200 hover:border-saffron-300 hover:shadow-warm hover:-translate-y-1.5 transition-all duration-300"
            >
              <div className={`inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br ${feature.chip} rounded-2xl mb-5 group-hover:scale-110 transition-transform duration-300`}>
                {feature.icon}
              </div>
              <h3 className="text-lg font-bold text-cocoa-900 mb-2.5">{feature.title}</h3>
              <p className="text-cocoa-600 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Dedicated Ad Strip */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mt-14"
        >
          <div className="mx-auto max-w-4xl rounded-2xl border border-dashed border-cream-300 bg-white p-4 flex justify-center">
            <BannerAd
              key="708f1310e8b739077a59073d869d1360"
              height={90}
              width={728}
              className="rounded-lg"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturesSection;
